export default __webpack_public_path__ + "static/alfred_custom_web_search-3002dbec0632e1f53ee6758b71a3cfaa.png";